import type { ProductCardType } from '@shared/types/product';

import { memo } from 'react';

import { useAddToCartHandle } from '@/screens/Cart/hooks/useAddToCartHandle';

import { Button } from '@shared/ui/Button';
import { HStack } from '@shared/ui/Stack';
import { formatPrice } from '@shared/utils/formatPrice/formatPrice';
import { YandexSplitBadge } from '@widgets/ProductCard/ui/CardVariant/YandexSplitBadge/YandexSplitBadge';

import { ComparisonButton } from '../../ComparisonButton/ComparisonButton';
import { FavoriteButton } from '../../FavoriteButton/FavoriteButton';
import cls from './Controls.module.scss';

export const Controls = memo<ProductCardType>((props) => {
  const { remainder, price, category, id } = props;
  const { productInCart, handleClickAddToCart } = useAddToCartHandle(props);

  const inStock = remainder !== undefined && +remainder !== 0;
  const cartButtonLabel = !inStock ? 'Нет в наличии' : productInCart ? 'Перейти в корзину' : 'Добавить в корзину';

  return (
    <div className={cls.wrap}>
      <HStack
        align={'end'}
        className={cls.top}
      >
        <div>
          <YandexSplitBadge
            className={cls.splitBadge}
            {...{ price }}
          />
          <div className={cls.price}>{formatPrice(price)}</div>
        </div>
        <HStack className={cls.buttons}>
          <ComparisonButton
            id={id}
            category={category}
            className={cls.comparison}
          />
          <FavoriteButton
            className={cls.favorite}
            iconSize={20}
            productId={props.id}
          />
        </HStack>
      </HStack>
      <Button
        disabled={!inStock}
        aria-label={cartButtonLabel}
        className={cls.button}
        size={'m'}
        fullWidth
        onClick={handleClickAddToCart}
        variant={productInCart ? 'tertiary' : 'accent'}
      >
        {cartButtonLabel}
      </Button>
    </div>
  );
});
